module.exports = __webpack_public_path__ + "static/media/suzuki-marine.95a67f04.png";